import React, { useContext, useMemo } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import List from "./List"

import * as style from "./References.module.scss"
import { mapAllResources, mapTags, compareVersions } from '../../utils/versioning'

const References = ({
  title,
  centeredTitle,
  tags = [],
  deprecatedTags = [],
  resources = [],
  showAll = false,
}) => {
  const microcopy = useContext(MicrocopyContext)

  const mappedTags = useMemo(() => mapTags(tags), [tags])
  const allResources = useMemo(() => mapAllResources(resources), [resources])

  const resourcesChunks = chunk(allResources, 10)
    .map((chunk, index) => ({
      name:
      index === 0 ? microcopy.text("reference.titles.other_resources") : null,
      resources: chunk,
    }))

  const deprecatedEndpoints = deprecatedTags.map((tag) => tag.endpoints).flat(2)
    // sort deprecated endpoints first by tag, then by version and then by opeartionId
    .sort((a, b) => {
      const tagComparison = a.tagKey.localeCompare(b.tagKey)
      if (tagComparison !== 0) return tagComparison
      const versionComparison = compareVersions(a.version, b.version)
      if (versionComparison !== 0) return versionComparison
      return a.key.localeCompare(b.key)
    })

  const deprecatedChunks = chunk(deprecatedEndpoints, 10)
    .map((chunk, index) => ({
      name: index === 0 ? microcopy.text("reference.titles.deprecated_entries") : null,
      deprecatedItems: chunk,
    }))

  return (
    <div>
      {title && (
        <h1 className={style.title} data-centered={centeredTitle}>
          <span>{title}</span>
        </h1>
      )}
      <div className={style.grid} data-wid data-show-all={showAll}>
        {mappedTags.filter(notEmpty).map((tag) => (
          <List key={tag.id} list={tag} sortByKey microcopy={microcopy} />
        ))}
        {resourcesChunks.map((chunk, index) => (
          <List key={index} list={chunk} hideHeaders microcopy={microcopy} />
        ))}
        {deprecatedChunks.map((chunk, index) => (
          <List key={index} list={chunk} hideHeaders microcopy={microcopy} />
        ))}
      </div>
    </div>
  )
}

// Chunk an array into multiple arrays of the same size
const chunk = (array, chunkSize) => {
  const myArray = [...array]
  const results = []
  while (myArray.length) {
    results.push(myArray.splice(0, chunkSize))
  }
  return results
}

const notEmpty = (tag) => tag.resources?.[0] || tag.endpoints?.[0]

export default References
